import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import "./datatablesource.scss";
import { color } from '@mui/system';
import { Box } from "@mui/material";
import imageLiveUrl from './utils/urlConverter/imageLiveUrl';

const filterOptions = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.title,
});
export const userColumns =(t) =>[
  {
    field: "userId",
    headerName: t("USER ID"),
    width: 110,

  },
  {
    field: "fullName",
    headerName: t("FULL NAME"),
    width: 150,
  },

  {
    field: "majorCategory",
    headerName: t("MAJOR CATEGORY"),
    width: 150,
  },
  {
    field: "minorCategory",
    headerName: t("MINOR CATEGORY"),
    width: 150,
  },
  {
    field: "majorDescription",
    headerName: t("MAJOR DESCRIPTION"),
    width: 150,
  },
  {
    field: "minorDescription",
    headerName: t("MINOR DESCRIPTION"),
    width: 190,
  },
  {
    field: "status",
    headerName: t("STATUS"),
    width: 80,
    renderCell: (params) => {

      return (
        <div
          style={{
            padding: "2px 5px",
            borderRadius: "5px",
            color: params.row.status === "active" ? "green" : "goldenrod",
            backgroundColor: params.row.status === "active" ? "rgba(0, 128, 0, 0.151)" : "rgba(189, 189, 3, 0.103)"

          }
          }

        >
          {t("Verified")}
        </div >
      );
    },
  },

];

export const userRows = [
  {

    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0001",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  },
  {
    userId: "12345",
    fullName: "John Doe",
    majorCategory: "01",
    minorCategory: "0002",
    majorDescription: "Restaurant",
    minorDescription: "Restaurant",
    status: "active",
  }]




export const userColumns2 = [
  {
    field: "name",
    headerName: "Name",
    width: 230,

  },
  {
    field: "taps",
    headerName: "Card Tap",
    width: 130,
  },

  {
    field: "digitalmuUrl",
    headerName: "Digitalmu Url",
    width: 260,
    renderCell: (params) => {
      return (
        // open the params in a new tab

        <span style={{ cursor: "pointer" }}
          onClick={() => window.open(params.row.digitalmuUrl, "_blank")}
        >
          {params.row.digitalmuUrl}
        </span>
      );
    },
  },
  {
    field: "contacts",
    headerName: "Lead No",
    width: 130,
    renderCell: (params) => {
      return (
        <div>
          {params.row.contacts.length}
        </div>

      );
    },

  },


];


export const userColumns2Rows = [
  {
    id: 1,
    name: "John Doe",
    taps: 2,
    digitalmuUrl: "https://www.digitalmu.com",
    contacts: [
      {
        id: 1,
        name: "John Doe",
        email: "sfsd@gmail.com"
      },
      {
        id: 2,
        name: "John Doe",
        email: "",

      }
    ]
  },
]



// department table columns
export const DepartmentTableColumns = t => [
  {
    field: 'TblNewDepartmentLitID',
    headerName: t('ID'),
    width: 120
  },
  {
    field: 'branchcode',
    headerName: t('BRANCH CODE'),
    width: 140
  },
  {
    field: 'DAONumber',
    headerName: t('DEPARTMENT CODE'),
    width: 160
  },
  {
    field: 'BusinessUnit',
    headerName: t('BUSINESS UNIT'),
    width: 160
  },
  {
    field: 'BUSINESSGROUP',
    headerName: t('BUSINESS GROUP'),
    width: 180
  },
  {
    field: 'HRMapping',
    headerName: t('HR MAPPING'),
    width: 160
  },
  {
    field: 'DaoName',
    headerName: t('DEPARTMENT NAME'),
    width: 220
  },
  {
    field: 'DaoArea',
    headerName: t('DEPARTMENT AREA'),
    width: 200
  }
]


export const DepartmentTableRows = [
  {
    id: 1,
    departmentCode: "IT",
    departmentName: "Information Technology",
  },
  {
    id: 2,
    departmentCode: "HR",
    departmentName: "Human Resources",
  },
  {
    id: 3,
    departmentCode: "FIN",
    departmentName: "Finance",
  },
  {
    id: 4,
    departmentCode: "SALES",
    departmentName: "Sales",
  },
  {
    id: 4,
    departmentCode: "SALES",
    departmentName: "Sales",
  },
  {
    id: 4,
    departmentCode: "SALES",
    departmentName: "Sales",
  },
  {
    id: 4,
    departmentCode: "SALES",
    departmentName: "Sales",
  },

];

// export const assetCategoriesColumn = [

//   {
//     field: "TblMAINSUBSeriesNoID",
//     headerName: "MAIN SUB SERIES ID",
//     width: 155,

//   },
//   {
//     field: "MainCategoryCode",
//     headerName: "MAIN CATEGORY CODE",
//     width: 120,
//   },

//   {
//     field: "SubCategoryCode",
//     headerName: "SUB CATEGORY CODE",
//     width: 120,
//   },

//   {
//     field: "MainSubSeriesNo",
//     headerName: "MAIN SUB SERIES NO",
//     width: 120,
//   },
//   {
//     field: "MainDescription",
//     headerName: "MAIN DESCRIPTION",
//     width: 190,
//   },
//   ,
//   {
//     field: "SubDescription",
//     headerName: "SUB DESCRIPTION",
//     width: 190,
//   },
//   // {
//   //   field: "SeriesNumber",
//   //   headerName: "SERIES NUMBER",
//   //   width: 120,
//   // },

// ];
// export const assetCategoriesColumn = [

//   {
//     field: "MajorCategory",
//     headerName: "Major Category",
//     width: 130,

//   },
//   {
//     field: "MInorCategory",
//     headerName: "Minor Category",
//     width: 140,
//   },

//   {
//     field: "TagNumber",
//     headerName: "TOTAL GENERATED NUMBERS",
//     width: 220,
//   },

//   {
//     field: "MajorCategoryDescription",
//     headerName: "MAJOR DESCRIPTION",
//     width: 210,
//   },
//   {
//     field: "MinorCategoryDescription",
//     headerName: "MINOR DESCRIPTION",
//     width: 210,
//   },
//   ,
//   {
//     field: "MainSubSeriesNo",
//     headerName: "RANK NO",
//     width: 80,
//   },

// ];

export const assetCategoriesColumn = t => [
  {
    field: 'TblMAINSUBSeriesNoID',
    headerName: t('MAIN SUB SERIES ID'),
    width: 155
  },
  {
    field: 'MainCategoryCode',
    headerName: t('MAIN CATEGORY CODE'),
    width: 130
  },

  {
    field: 'SubCategoryCode',
    headerName: t('SUB CATEGORY CODE'),
    width: 130
  },

  {
    field: 'MainSubSeriesNo',
    headerName: t('MAIN SUB SERIES NO'),
    width: 120
  },
  {
    field: 'MainDescription',
    headerName: t('MAIN DESCRIPTION'),
    width: 190
  },

  {
    field: 'SubDescription',
    headerName: t('SUB DESCRIPTION'),
    width: 190
  },
  {
    field: 'SeriesNumber',
    headerName: t('SERIES NUMBER'),
    width: 140
  }
]



export const assetCategoriesRows = [
  {
    majorCategory: "01",
    minorCategory: "0001",
    totalGeneratedNumbers: 2,
    majorDescription: "Information Technology",
    minorDescription: "Laptop",
    rankNo: 1,
  },
  {
    majorCategory: "01",
    minorCategory: "0001",
    totalGeneratedNumbers: 2,
    majorDescription: "Information Technology",
    minorDescription: "Desktop",
    rankNo: 2,
  },
  {
    majorCategory: "01",
    minorCategory: "0001",
    totalGeneratedNumbers: 2,
    majorDescription: "Information Technology",
    minorDescription: "Printer",
    rankNo: 3,
  },
  {
    majorCategory: "01",
    minorCategory: "002",
    totalGeneratedNumbers: 2,
    majorDescription: "Information Technology",
    minorDescription: "Scanner",
    rankNo: 4,
  },

];







export const assetOtherData = t => [
  {
    field: 'CityCode',
    headerName: t('CITY CODE'),
    width: 150
  },
  {
    field: 'CityName',
    headerName: t('CITY NAME'),
    width: 220
  },
  {
    field: 'RegionCode',
    headerName: t('REGION CODE'),
    width: 140
  }
]


export const assetOtherDataRows = [
  {
    countryCode: "NG",
    countryName: "Nigeria",
    regionCode: "NG-AB",
    regionName: "Abia",
    cityCode: "NG-AB-AB",
    cityName: "Abia",
  },
  {

    countryCode: "SA",
    countryName: "Saudi Arabia",
    regionCode: "SA-AB",
    regionName: "Abia",
    cityCode: "SA-AB-AB",
    cityName: "Abia",
  },
  {

    countryCode: "SA",
    countryName: "Saudi Arabia",
    regionCode: "SA-AB",
    regionName: "Abia",
    cityCode: "SA-AB-AB",
    cityName: "Abia",
  },
  {

    countryCode: "SA",
    countryName: "Saudi Arabia",
    regionCode: "SA-AB",
    regionName: "Abia",
    cityCode: "SA-AB-AB",
    cityName: "Abia",
  },
  {

    countryCode: "SA",
    countryName: "Saudi Arabia",
    regionCode: "SA-AB",
    regionName: "Abia",
    cityCode: "SA-AB-AB",
    cityName: "Abia",
  },
  {

    countryCode: "SA",
    countryName: "Saudi Arabia",
    regionCode: "SA-AB",
    regionName: "Abia",
    cityCode: "SA-AB-AB",
    cityName: "Abia",
  }
];





export const brandListColumns = t => [
  {
    field: 'tblMajorCode',
    headerName: t('Major Category'),
    width: 230
  },
  {
    field: 'TblMakeMainCode',
    headerName: t('Minor Category'),
    width: 240
  },

  {
    field: 'TblMakeName',
    headerName: t('DESCRIPTION'),
    width: 420
  }
]



export const brandListRows = [
  {
    majorCategory: "01",
    minorCategory: "0001",
    description: "Dell",
  },
  {
    majorCategory: "01",
    minorCategory: "0001",
    description: "HP",
  },
  {
    majorCategory: "01",
    minorCategory: "0001",
    description: "Lenovo",
  },
  {
    majorCategory: "01",
    minorCategory: "002",
    description: "Samsung",
  },

  {
    majorCategory: "01",
    minorCategory: "0001",
    description: "Lenovo",
  },
  {
    majorCategory: "01",
    minorCategory: "002",
    description: "Samsung",
  },

];




export const allAssetsColumns = t => [
  {
    field: 'Podate',
    headerName: t('PODATE'),
    width: 100
  },
  {
    field: 'MajorCategory',
    headerName: t('Major Category'),
    width: 180
  },
  {
    field: 'MajorCategoryDescription',
    headerName: t('Major Category Description'),
    width: 230
  },
  {
    field: 'MInorCategory',
    headerName: t('Minor Category'),
    width: 180
  },
  {
    field: 'MinorCategoryDescription',
    headerName: t('Minor Category Description'),
    width: 230
  },

  {
    field: 'TagNumber',
    headerName: t('TAG NUMBER'),
    width: 150
  },
  {
    field: 'sERIALnUMBER',
    headerName: t('SERIAL NUMBER'),
    width: 150
  },
  {
    field: 'aSSETdESCRIPTION',
    headerName: t('ASSET DESCRIPTION'),
    width: 200
  },
  {
    field: 'assettYPE',
    headerName: t('ASSET TYPE'),
    width: 100
  },
  {
    field: 'aSSETcONDITION',
    headerName: t('ASSET CONDITION'),
    width: 150
  },
  {
    field: 'cOUNTRY',
    headerName: t('COUNTRY'),
    width: 150
  },
  {
    field: 'rEGION',
    headerName: t('REGION'),
    width: 150
  },
  {
    field: 'CityName',
    headerName: t('CITY'),
    width: 150
  },
  {
    field: 'departmDaoentCode',
    headerName: t('DEPARTMENT CODE'),
    width: 150
  },
  {
    field: 'DaoName',
    headerName: t('DEPARTMENT NAME'),
    width: 180
  },
  {
    field: 'BusinessUnit',
    headerName: t('BUSINESS UNIT'),
    width: 150
  },
  {
    field: 'BUILDINGNO',
    headerName: t('BUILDING NO'),
    width: 150
  },
  {
    field: 'FLOORNO',
    headerName: t('FLOOR NO'),
    width: 150
  },
  {
    field: 'EMPLOYEEID',
    headerName: t('EMPLOYEE ID'),
    width: 130
  },
  {
    field: 'ponUmber',
    headerName: t('PO NUMBER'),
    width: 130
  },
  {
    field: 'DeliveryNoteNo',
    headerName: t('DELIVERY NOTENO'),
    width: 130
  },
  {
    field: 'Supplier',
    headerName: t('SUPPLIER'),
    width: 130
  },
  {
    field: 'InvoiceNo',
    headerName: t('INVOICE NO'),
    width: 130
  },
  {
    field: 'InvoiceDate',
    headerName: t('INVOICE DATE'),
    width: 130
  },
  {
    field: 'ModelofAsset',
    headerName: t('MODEL/FACUTURER'),
    width: 130
  },
  {
    field: 'Manufacturer',
    headerName: t('MANUFACTURER'),
    width: 130
  },
  {
    field: 'Ownership',
    headerName: t('OWNER SHIP'),
    width: 130
  },
  {
    field: 'Bought',
    headerName: t('BOUGHT'),
    width: 130
  },
  {
    field: 'TerminalID',
    headerName: t('TERMINAL ID'),
    width: 130
  },
  {
    field: 'ATMNumber',
    headerName: t('ATM NUMBER'),
    width: 130
  },
  {
    field: 'LocationTag',
    headerName: t('LOCATION TAG'),
    width: 130
  },
  {
    field: 'buildingName',
    headerName: t('BUILDING NAME'),
    width: 130
  },
  {
    field: 'buildingAddress',
    headerName: t('BUILDING ADDRESS'),
    width: 130
  },
  {
    field: 'majorCategoryAndMinorCategory',
    headerName: t('MAJOR CATEGORY PLUS MINOR CATEGORY'),
    width: 130
  },

  {
    field: 'UserLoginID',
    headerName: t('USER LOGIN ID'),
    width: 130
  },
  {
    field: 'MainSubSeriesNo',
    headerName: t('MAIN/SUB SERIES NUMBER'),
    width: 130
  },
  {
    field: 'assetdatecaptured',
    headerName: t('ASSET DATE CAPTURED'),
    width: 130
  },
  {
    field: 'assetTimeCaptured',
    headerName: t('ASSET TIME CAPTURED'),
    width: 130
  },
  {
    field: 'assetdatescanned',
    headerName: t('ASSET DATE SCANNED'),
    width: 130
  },
  {
    field: 'assettimeScanned',
    headerName: t('ASSET TIME SCANNED'),
    width: 150
  },
  {
    field: 'QTY',
    headerName: t('QTY'),
    width: 100
  },
  {
    field: 'PhoneExtNo',
    headerName: t('PHONE/EXT NO'),
    width: 150
  },
  {
    field: 'FullLocationDetails',
    headerName: t('FULL LOCATION DETAILS'),
    width: 250
  }
]




//User Admin Panel Assets Columns 
export const allUserAssetsColumns = t => [
  {
    field: 'MajorCategory',
    headerName: t('Major Category'),
    width: 180
  },
  {
    field: 'MajorCategoryDescription',
    headerName: t('Major Category Description'),
    width: 230
  },
  {
    field: 'MInorCategory',
    headerName: t('Minor Category'),
    width: 180
  },
  {
    field: 'MinorCategoryDescription',
    headerName: t('Minor Category Description'),
    width: 230
  },

  {
    field: 'TagNumber',
    headerName: t('TAG NUMBER'),
    width: 150
  },
  {
    field: 'sERIALnUMBER',
    headerName: t('SERIAL NUMBER'),
    width: 150
  },
  {
    field: 'aSSETdESCRIPTION',
    headerName: t('ASSET DESCRIPTION'),
    width: 200
  },
  {
    field: 'Manufacturer',
    headerName: t('MANUFACTURER'),
    width: 130
  },
  {
    field: 'ModelofAsset',
    headerName: t('MODEL/FACUTURER'),
    width: 130
  },
  {
    field: 'UserLoginID',
    headerName: t('USER LOGIN ID'),
    width: 130
  },
  {
    field: 'assettYPE',
    headerName: t('ASSET TYPE'),
    width: 100
  },
  {
    field: 'aSSETcONDITION',
    headerName: t('ASSET CONDITION'),
    width: 150
  },
  {
    field: 'Podate',
    headerName: t('PODATE'),
    width: 100
  },
  {
    field: 'DeliveryNoteNo',
    headerName: t('DELIVERY NOTENO'),
    width: 130
  },
  {
    field: 'InvoiceNo',
    headerName: t('INVOICE NO'),
    width: 130
  },
  {
    field: 'InvoiceDate',
    headerName: t('INVOICE DATE'),
    width: 130
  },
  {
    field: 'LocationTag',
    headerName: t('LOCATION TAG'),
    width: 130
  },
  {
    field: 'EMPLOYEEID',
    headerName: t('EMPLOYEE ID'),
    width: 130
  },
  {
    field: 'PhoneExtNo',
    headerName: t('PHONE/EXT NO'),
    width: 150
  },
  {
    field: 'ponUmber',
    headerName: t('PO NUMBER'),
    width: 130
  },
  {
    field: 'FLOORNO',
    headerName: t('FLOOR NO'),
    width: 150
  },
  {
    field: 'Dao',
    headerName: t('DEPARTMENT CODE'),
    width: 150
  },
  {
    field: 'DaoName',
    headerName: t('DEPARTMENT NAME'),
    width: 180
  },
  {
    field: 'buildingName',
    headerName: t('BUILDING NAME'),
    width: 130
  },
  {
    field: 'CityName',
    headerName: t('CITY'),
    width: 150
  },
  {
    field: 'rEGION',
    headerName: t('REGION'),
    width: 150
  },
  {
    field: 'cOUNTRY',
    headerName: t('COUNTRY'),
    width: 150
  },
  {
    field: 'BusinessUnit',
    headerName: t('BUSINESS UNIT'),
    width: 150
  },
  {
    field: 'Supplier',
    headerName: t('SUPPLIER'),
    width: 130
  },
  {
    field: 'Ownership',
    headerName: t('OWNER SHIP'),
    width: 130
  },
  {
    field: 'ATMNumber',
    headerName: t('ATM NUMBER'),
    width: 130
  },
  {
    field: 'BUILDINGNO',
    headerName: t('BUILDING NO'),
    width: 150
  },
  {
    field: 'buildingAddress',
    headerName: t('BUILDING ADDRESS'),
    width: 130
  },
  {
    field: 'majorCategoryAndMinorCategory',
    headerName: t('MAJOR CATEGORY PLUS MINOR CATEGORY'),
    width: 130
  },

  {
    field: 'MainSubSeriesNo',
    headerName: t('MAIN/SUB SERIES NUMBER'),
    width: 130
  },
  {
    field: 'assetdatecaptured',
    headerName: t('ASSET DATE CAPTURED'),
    width: 130
  },
  {
    field: 'assetTimeCaptured',
    headerName: t('ASSET TIME CAPTURED'),
    width: 130
  },
  {
    field: 'assetdatescanned',
    headerName: t('ASSET DATE SCANNED'),
    width: 130
  },
  {
    field: 'assettimeScanned',
    headerName: t('ASSET TIME SCANNED'),
    width: 150
  },
  {
    field: 'QTY',
    headerName: t('QTY'),
    width: 100
  },
  {
    field: 'FullLocationDetails',
    headerName: t('FULL LOCATION DETAILS'),
    width: 250
  },
  {
    field: 'Bought',
    headerName: t('BOUGHT'),
    width: 130
  },
  {
    field: 'TerminalID',
    headerName: t('TERMINAL ID'),
    width: 130
  }
]





export const allAssetsRows = [

  {
    assetId: "0000",
    majorCategory: "01",
    majorCategoryDescription: "Computers",
    minorCategory: "0001",
    minorCategoryDescription: "Lenovo",
    tagNumber: "0000",
    serialNumber: "0000",
    assetDescription: "0000",
    assetType: "0000",
    assetCondition: "0000",
    country: "0000",
    region: "0000",
    city: "0000",
    departmentCode: "0000",
    departmentName: "0000",
    businessUnit: "0000",
    buildingNo: "0000",
    floorNo: "0000",
    employeeId: "0000",
    poNumber: "0000",
    deliveryNoteno: "0000",
    supplier: "0000",
    invoiceNo: "0000",
    invoiceDate: "0000",
    modelfacuturer: "0000",
    manufacturer: "0000",
    ownerShip: "0000",
    bought: "0000",
    terminalId: "0000",
    AtmNumber: "0000",
    locationTag: "0000",
    buildingName: "0000",
    buildingAddress: "0000",
    majorCategoryAndMinorCategory: "0000",
    userLoginId: "0000",
    MainSubSeriesNumber: "0000",
    assetDateCaptured: "0000",
    assetTimeCaptured: "0000",
    assetDateScanned: "0000",
    assetTimeScanned: "0000",
    qty: "0000",
    phoneextno: "0000",
    fullLocationDetails: "0000",
  },

  {
    assetId: "0000",
    majorCategory: "01",
    majorCategoryDescription: "Computers",
    minorCategory: "0001",
    minorCategoryDescription: "Lenovo",
    tagNumber: "0000",
    serialNumber: "0000",
    assetDescription: "0000",
    assetType: "0000",
    assetCondition: "0000",
    country: "0000",
    region: "0000",
    city: "0000",
    departmentCode: "0000",
    departmentName: "0000",
    businessUnit: "0000",
    buildingNo: "0000",
    floorNo: "0000",
    employeeId: "0000",
    poNumber: "0000",
    deliveryNoteno: "0000",
    supplier: "0000",
    invoiceNo: "0000",
    invoiceDate: "0000",
    modelfacuturer: "0000",
    manufacturer: "0000",
    ownerShip: "0000",
    bought: "0000",
    terminalId: "0000",
    AtmNumber: "0000",
    locationTag: "0000",
    buildingName: "0000",
    buildingAddress: "0000",
    majorCategoryAndMinorCategory: "0000",
    userLoginId: "0000",
    MainSubSeriesNumber: "0000",
    assetDateCaptured: "0000",
    assetTimeCaptured: "0000",
    assetDateScanned: "0000",
    assetTimeScanned: "0000",
    qty: "0000",
    phoneextno: "0000",
    fullLocationDetails: "0000",
  },
  {
    assetId: "0000",
    majorCategory: "01",
    majorCategoryDescription: "Computers",
    minorCategory: "0001",
    minorCategoryDescription: "Lenovo",
    tagNumber: "0000",
    serialNumber: "0000",
    assetDescription: "0000",
    assetType: "0000",
    assetCondition: "0000",
    country: "0000",
    region: "0000",
    city: "0000",
    departmentCode: "0000",
    departmentName: "0000",
    businessUnit: "0000",
    buildingNo: "0000",
    floorNo: "0000",
    employeeId: "0000",
    poNumber: "0000",
    deliveryNoteno: "0000",
    supplier: "0000",
    invoiceNo: "0000",
    invoiceDate: "0000",
    modelfacuturer: "0000",
    manufacturer: "0000",
    ownerShip: "0000",
    bought: "0000",
    terminalId: "0000",
    AtmNumber: "0000",
    locationTag: "0000",
    buildingName: "0000",
    buildingAddress: "0000",
    majorCategoryAndMinorCategory: "0000",
    userLoginId: "0000",
    MainSubSeriesNumber: "0000",
    assetDateCaptured: "0000",
    assetTimeCaptured: "0000",
    assetDateScanned: "0000",
    assetTimeScanned: "0000",
    qty: "0000",
    phoneextno: "0000",
    fullLocationDetails: "0000",
  },
];




export const assetContitionColumn = t => [
  {
    field: 'TblConditionCode',
    headerName: t('CODE'),
    width: 450
  },
  {
    field: 'TblConditionDescription',
    headerName: t('DESCRIPTION'),
    width: 450
  }
]


export const assetContitionRows = [
  {
    code: "00",
    description: "EXCELLENT",

  },
  {
    code: "02",
    description: "GOOD",

  },
  {
    code: "03",
    description: "FAIR",
  }
]


export const employeeListColumn = t => [
  {
    field: 'EmpID',
    headerName: t('EMPLOYEE ID'),
    width: 200
  },
  {
    field: 'EmpName',
    headerName: t('EMPLOYEE NAME'),
    width: 250
  },
  {
    field: 'EmpRegion',
    headerName: t('EMPLOYEE REGION'),
    width: 200
  },
  {
    field: 'EmpUnit',
    headerName: t('EMPLOYEE UNIT'),
    width: 200
  },
  {
    field: 'EmpDivision',
    headerName: t('EMPLOYEE DIVISION'),
    width: 220
  }
]


export const employeeListRows = [
  {
    employeeId: "0000",
    employeeName: "Abdul Majid",
  },
  {
    employeeId: "0001",
    employeeName: "Abdul Majid",
  },
  {
    employeeId: "0000",
    employeeName: "Abdul Majid",
  },
  {
    employeeId: "0001",
    employeeName: "Abdul Majid",
  },

  {
    employeeId: "0000",
    employeeName: "Abdul Majid",
  },
  {
    employeeId: "0001",
    employeeName: "Abdul Majid",
  },
  {
    employeeId: "0000",
    employeeName: "Abdul Majid",
  },
  {
    employeeId: "0001",
    employeeName: "Abdul Majid",
  },

]


export const locationTagColumn = t => [
  {
    field: 'tagNo',
    headerName: t('TAG NO'),
    width: 200
  },
  {
    field: 'name',
    headerName: t('NAME'),
    width: 300
  }
]


export const locationTagRows = [
  {
    tagNo: "0000",
    name: "Abdul Majid",
  },
  {
    tagNo: "0001",
    name: "Hasnain",
  },
  {
    tagNo: "0000",
    name: "Abdul Majid",
  },
  {
    tagNo: "0001",
    name: "Hasnain",
  },

]

export const userAcccountTableOneColumn = t => [
  {
    field: 'loginname',
    headerName: t('USER ID'),
    width: 180
  },
  {
    field: 'loginpass',
    headerName: t('PASSWORD'),
    width: 200
  },
  {
    field: 'loginfullname',
    headerName: t('FULL NAME'),
    width: 280
  }
  // {
  //   field: "roles",
  //   headerName: "ROLES",
  //   width: 600,
  //   renderCell: (params) => {
  //     return (

  //       <Autocomplete
  //         id="filter-demo"
  //         className='roles-autocomplete'
  //         options={rolesData}
  //         getOptionLabel={(option) => option.title}
  //         filterOptions={filterOptions}
  //         sx={{
  //           // change label color to gray
  //           '& .MuiInputLabel-root': {
  //             color: 'gray',
  //           },
  //           width: '33rem',
  //           color: 'gray',
  //           '& .MuiAutocomplete-inputRoot': {
  //             color: 'gray',
  //           },
  //           '& .MuiAutocomplete-input': {
  //             color: 'gray',
  //           },
  //           '& .MuiAutocomplete-option': {
  //             color: 'gray',

  //           },
  //           '& .MuiAutocomplete-option[data-focus="true"]': {
  //             backgroundColor: '#7451f8',

  //           },
  //           '& .MuiAutocomplete-option[data-focus="true"] .MuiAutocomplete-optionLabel': {
  //             color: 'white',
  //           },
  //           // change border color to gray
  //           '& .MuiOutlinedInput-root': {
  //             '& fieldset': {
  //               borderColor: 'gray',
  //             },
  //             '&:hover fieldset': {
  //               borderColor: 'gray',
  //             },
  //           },
  //         }
  //         }
  //         // set first option as default
  //         // defaultValue={rolesData[0]}
  //         renderInput={(params) => <TextField {...params} label="Roles" />}
  //       />
  //     );
  //   },
  // },
]


export const dropdownOptions = [
  {
    field: "roles",
    headerName: "ROLES",
    width: 600,
    renderCell: (params) => {
      return (

        <Autocomplete
          id="filter-demo"
          className='roles-autocomplete'
          options={rolesData}
          getOptionLabel={(option) => option.title}
          filterOptions={filterOptions}
          sx={{
            // change label color to gray
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
            width: '33rem',
            color: 'gray',
            '& .MuiAutocomplete-inputRoot': {
              color: 'gray',
            },
            '& .MuiAutocomplete-input': {
              color: 'gray',
            },
            '& .MuiAutocomplete-option': {
              color: 'gray',

            },
            '& .MuiAutocomplete-option[data-focus="true"]': {
              backgroundColor: '#7451f8',

            },
            '& .MuiAutocomplete-option[data-focus="true"] .MuiAutocomplete-optionLabel': {
              color: 'white',
            },
            // change border color to gray
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'gray',
              },
              '&:hover fieldset': {
                borderColor: 'gray',
              },
            },
          }
          }
          // set first option as default
          // defaultValue={rolesData[0]}
          renderInput={(params) => <TextField {...params} label="Roles" />}
        />
      );
    },
  }];
const rolesData = [
  { title: '0012, Description: FAT CLIENT: Able to view asset details' },
  { title: '0232, Description: FAT CLIENT: Able to view asset details' },
  { title: '2321, Description: FAT CLIENT: Able to view asset details' },
  { title: '3542, Description: FAT CLIENT: Able to view asset details' },

]
export const userAcccountTableTwoColumn =(t)=> [
  {
    field: "RoleID",
    headerName: t("ROLE ID"),
    width: 70,
  },
  {
    field: "RoleDescription",
    headerName: t("ROLE DESCRIPTION"),
    width: 400,
  },

]
export const AllUserRolesColumns = t => [
  {
    field: 'RoleID',
    headerName: t('ROLE ID'),
    width: 70
  },
  {
    field: 'RoleDescription',
    headerName: t('ROLE DESCRIPTION'),
    width: 400
  }
]


export const userAcccountTableOneRows = [
  {
    userId: "0000",
    loginPassword: "****",
    fullName: "Abdul Majid",
  },
  {
    userId: "0001",
    loginPassword: "****",
    fullName: "Hasnain",
  },
  {
    userId: "0000",
    loginPassword: "****",
    fullName: "Abdul Majid",
  },
  {
    userId: "0001",
    loginPassword: "****",
    fullName: "Hasnain",
  },
  {
    userId: "0000",
    loginPassword: "****",
    fullName: "Abdul Majid",
  },
]

export const userAcccountTableTwoRows = [
  {
    roleId: "0000",
    roleDescription: "FAT CLIENT: Able to view asset details",
  },
  {
    roleId: "0000",
    roleDescription: "FAT CLIENT: Able to view asset details",
  }
  ,
  {
    roleId: "0000",
    roleDescription: "FAT CLIENT: ALLOW TO ACCESS ASSET MANAGEMENT SYSTEM",
  },
  {
    roleId: "0001",
    roleDescription: "FAT CLIENT: ALLOW TO ACCESS ASSET MANAGEMENT SYSTEM",
  },
  {
    roleId: "0000",
    roleDescription: "FAT CLIENT: Able to view asset details",
  }

]




export const allTemplatesColumn = t => [
  {
    field: 'name',
    headerName: t('Name'),
    width: 180
  },
  {
    field: 'name_ar',
    headerName: t('Name Arabic'),
    width: 180
  },
  {
    field: 'slug',
    headerName: t('Slug'),
    width: 180
  },
  {
    field: 'seo_description',
    headerName: t('SEO Description'),
    width: 180
  },
  {
    field: 'seo_description_ar',
    headerName: t('SEO Description Arabic'),
    width: 180
  },
  {
    field: 'status',
    headerName: t('Status'),
    width: 120,
    renderCell: params => (
      <div
        style={{
          padding: '5px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderRadius: '20px',
          border: '2px solid',
          borderColor: params.row.status === 1 ? 'green' : 'red',
          color: params.row.status === 1 ? 'green' : 'red'
        }}
      >
        {params.row.status === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,

    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,

    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]



export const megamenuDataColumn = (t, i18n) => [
  {
    field: 'name_en',
    headerName: t('Name[English]'),
    width: 180,
    renderCell: params => (
      <Box dangerouslySetInnerHTML={{ __html: params.value }} />
    )
  },
  {
    field: 'name_ar',
    headerName: t('Name[Arabic]'),
    width: 260,
    renderCell: params => (
      <Box dangerouslySetInnerHTML={{ __html: params.value }} />
    )
  },
  {
    field: 'status',
    headerName: t('Status'),
    width: 180,
    valueGetter: params => {
      return params.value === 1 ? 'Active' : 'Inactive'
    }
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]


export const CategoriesDataColumn = (t, i18n) => [
  {
    field: 'category_name_en',
    headerName: t('Category Name[English]'),
    width: 260
  },
  {
    field: 'category_name_ar',
    headerName: t('Category Name[Arabic]'),
    width: 260
  },
  {
    field: 'megamenu_id',
    headerName: t('Mega Menu'),
      renderCell: (params) => (
      <Box dangerouslySetInnerHTML={{ __html: params.value }} />
    ),
    width: 200
  },
  {
    field: 'description',
    headerName: t('Description'),
    width: 260
  },
  {
    field: 'url',
    headerName: t('Url'),
    width: 260
  },
  {
    field: 'meta_title',
    headerName: t('Meta Title'),
    width: 200
  },
  {
    field: 'meta_description',
    headerName: t('Meta Description'),
    width: 260
  },
  {
    field: 'image',
    headerName: t('Image'),
    width: 200,
     renderCell: (params) => (
      <>
      <img
        src={imageLiveUrl(params.row.image)}
        alt="Image"
        style={{
          width: "77%",
          height: "77%",
          objectFit: "fill",
        }}
      />
      {console.log(imageLiveUrl(params.row.image))}
      </>
      
    ),
  },
  {
    field: 'status',
    headerName: t('Status'),
    width: 180,
    valueGetter: params => {
      return params.value === 1 ? 'Active' : 'Inactive'
    }
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]

export const footerMenuDataColumn = (t) => [
  {
    field: 'category_name_en',
    headerName: t('Category Name[English]'),
    width: 180
  },
  {
    field: 'category_name_ar',
    headerName: t('Category Name[Arabic]'),
    width: 260
  },
  {
    field: 'url',
    headerName: t('Url'),
    width: 260
  },
  {
    field: 'parent_id',
    headerName: t('Category'),
    width: 150
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    renderCell: params => (
      <div
        style={{
          padding: '5px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderRadius: '20px',
          border: '2px solid',
          borderColor: params.row.status === 1 ? 'green' : 'red',
          color: params.row.status === 1 ? 'green' : 'red'
        }}
      >
        {params.row.status === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]


export const stepDataColumn = (t, i18n) => [
  {
    field: 'Step',
    headerName: t('Step'),
    width: 260
  },
  {
    field: 'Title',
    headerName: t('Title'),
    width: 200
  },
  {
    field: 'Description',
    headerName: t('Description'),
    width: 200
  },
  {
    field: 'Image',
    headerName: t('Image'),
    width: 260
  },
  {
    field: 'status',
    headerName: t('Status'),
    width: 180,
   renderCell: params => (
  <div
    style={{
      padding: '5px',
      paddingLeft: '10px',
      paddingRight: '10px',
      borderRadius: '20px',
      border: '2px solid',
      borderColor: params.row.status === 1 ? 'green' : 'red',
      color: params.row.status === 1 ? 'green' : 'red'
    }}
  >
    {params.row.status === 1 ? 'Active' : 'Inactive'}
  </div>
)},
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]


export const headerDataColumn = (t, i18n) => [
  {
    field: 'caption',
    headerName: t('Caption'),
    width: 260
  },
  {
    field: 'caption_ar',
    headerName: t('Caption [Arabic]'),
    width: 200
  },
  {
    field: 'title',
    headerName: t('Title'),
    width: 200
  },
  {
    field: 'title_ar',
    headerName: t('Title [Arabic]'),
    width: 260
  }, {
    field: 'description',
    headerName: t('Description'),
    width: 260
  }, {
    field: 'description_ar',
    headerName: t('Description [Arabic]'),
    width: 260
  }, {
    field: 'image',
    headerName: t('Image'),
    width: 200,
     renderCell: (params) => (
      <img
        src={imageLiveUrl(params.row.image)}
        alt="Image"
        style={{
          width: "77%",
          height: "77%",
          objectFit: "fill",
        }}
      />
    ),
  }, {
    field: 'url',
    headerName: t('Url'),
    width: 150
  }, {
    field: 'button',
    headerName: t('Button'),
    width: 150
  },
  {
    field: 'status',
    headerName: t('Status'),
    width: 180,
    renderCell: params => (
      <div
        style={{
          padding: '5px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderRadius: '20px',
          border: '2px solid',
          borderColor: params.row.status === 1 ? 'green' : 'red',
          color: params.row.status === 1 ? 'green' : 'red'
        }}
      >
        {params.row.status === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]

export const steperDataColumn = (t, i18n) => [
  {
    field: 'caption',
    headerName: t('Step'),
    width: 120
  },
  {
    field: 'title',
    headerName: t('Title'),
    width: 200
  },
  {
    field: 'title_ar',
    headerName: t('Title [Arabic]'),
    width: 200
  },
  {
    field: 'description',
    headerName: t('Description'),
    width: 260
  },
  {
    field: 'description_ar',
    headerName: t('Description [Arabic]'),
    width: 260
  },
  {
    field: 'image',
    headerName: t('Image'),
    width: 200,
    renderCell: params => (
      <img
        src={imageLiveUrl(params.row.image)}
        alt='Image'
        style={{
          width: '77%',
          height: '77%',
          objectFit: 'fill'
        }}
      />
    )
  },
  {
    field: 'status',
    headerName: t('Status'),
    width: 180,
    renderCell: params => (
      <div
        style={{
          padding: '5px',
          paddingLeft: '10px',
          paddingRight: '10px',
          borderRadius: '20px',
          border: '2px solid',
          borderColor: params.row.status === 1 ? 'green' : 'red',
          color: params.row.status === 1 ? 'green' : 'red'
        }}
      >
        {params.row.status === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]

export const silderDataColumn = t => [
  {
    field: 'title',
    headerName: t('Title'),
    width: 180
  },
  {
    field: 'title_ar',
    headerName: t('Title [Arabic]'),
    width: 180
  },
  {
    field: 'description',
    headerName: t('Description'),
    width: 500
  },
  {
    field: 'description_ar',
    headerName: t('Description [Arabic]'),
    width: 500
  },
  {
    field: 'caption',
    headerName: t('Caption'),
    width: 200
  },
  {
    field: 'caption_ar',
    headerName: t('Caption [Arabic]'),
    width: 200
  },
  {
    field: 'url',
    headerName: t('Link'),
    width: 200
  },
  {
    field: 'image',
    headerName: t('Image'),
    width: 200,
    renderCell: params => (
      <img
        src={imageLiveUrl(params.row.image)}
        alt='Image'
        style={{
          width: '77%',
          height: '77%',
          objectFit: 'fill'
        }}
      />
    )
  },

  // {
  //   field: 'image_ar',
  //   headerName: t('Image [Arabic]'),
  //   width: 200,
  //   renderCell: params => (
  //     <img
  //       src={imageLiveUrl(params.row.image_ar)}
  //       alt='Image'
  //       style={{
  //         width: '77%',
  //         height: '77%',
  //         objectFit: 'fill'
  //       }}
  //     />
  //   )
  // },
  {
    field: 'status',
    headerName: t('status'),
    width: 180,
    renderCell: params => (
      <div
        style={{
          padding: '4px 8px',
          borderRadius: '20px',
          border: '2px solid',
          background: params.value === 1 ? 'green' : 'red',
          color: 'white'
        }}
      >
        {params.value === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]

export const faqsDataColumn = t => [
  {
    field: 'title',
    headerName: t('Title'),
    width: 180
  },
  {
    field: 'title_ar',
    headerName: t('Title [Arabic]'),
    width: 180
  },
  {
    field: 'description',
    headerName: t('Description'),
    width: 500
  },
  {
    field: 'description_ar',
    headerName: t('Description [Arabic]'),
    width: 500
  },
  {
    field: 'status',
    headerName: t('status'),
    width: 180,
    renderCell: params => (
      <div
        style={{
          padding: '4px 8px',
          borderRadius: '20px',
          border: '2px solid',
          background: params.value === 1 ? 'green' : 'red',
          color: 'white'
        }}
      >
        {params.value === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]

export const languageDataColumn = t => [
  {
    field: 'id',
    headerName: t('ID'),
    width: 80
  },
  {
    field: 'key',
    headerName: t('Key'),
    width: 180
  },
  {
    field: 'value',
    headerName: t('Value'),
    width: 200
  },
  {
    field: 'nl',
    headerName: t('NL'),
    width: 200
  }
]

export const Cardsection2DataColumn = t => [
  {
    field: 'title',
    headerName: t('Title'),
    width: 180
  },
  {
    field: 'title_ar',
    headerName: t('Title [Arabic]'),
    width: 180
  },
  {
    field: 'description',
    headerName: t('Description'),
    width: 500
  },
  {
    field: 'description_ar',
    headerName: t('Description [Arabic]'),
    width: 500
  },
   {
    field: 'button',
    headerName: t('Button'),
    width: 180
  },
  {
    field: 'url',
    headerName: t('Link'),
    width: 200
  },
  {
    field: 'status',
    headerName: t('status'),
    width: 180,
    renderCell: params => (
      <div
        style={{
          padding: '4px 8px',
          borderRadius: '20px',
          border: '2px solid',
          background: params.value === 1 ? 'green' : 'red',
          color: 'white'
        }}
      >
        {params.value === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]

export const HeadingDataColumn = t => [
  {
    field: 'title',
    headerName: t('Title'),
     width: 320,
     renderCell: (params) => (
      <div
        style={{
          overflowX: "auto",
          maxWidth: "320px",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: 'title_ar',
    headerName: t('Title [Arabic]'),
    width: 320,
    renderCell: (params) => (
      <div
        style={{
          overflowX: "auto",
          maxWidth: "320px",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: 'status',
    headerName: t('status'),
    width: 160,
    renderCell: params => (
      <div
        style={{
          padding: '4px 8px',
          borderRadius: '20px',
          border: '2px solid',
          background: params.value === 1 ? 'green' : 'red',
          color: 'white'
        }}
      >
        {params.value === 1 ? 'Active' : 'Inactive'}
      </div>
    )
  },
  {
    field: 'created_at',
    headerName: t('Created At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  },
  {
    field: 'updated_at',
    headerName: t('Updated At'),
    width: 180,
    type: 'dateTime',
    valueGetter: params => {
      // Convert the string date to a Date object
      return params.value ? new Date(params.value) : null
    }
  }
]
